<h2>Сезоны пользователя {{ userId }}</h2>
<mat-tab-group>
  <mat-tab label="Сезоны">
    <form [formGroup]="seasonForm" (ngSubmit)="apply('seasons')">
      <div class="filters">
        <mat-form-field
          ><mat-label>ID сезонов</mat-label
          ><input matInput formControlName="ids" placeholder="1, 2, 3"
        /></mat-form-field>
        <mat-form-field
          ><mat-label>Статусы</mat-label
          ><mat-select formControlName="statuses" multiple
            ><mat-option
              *ngFor="let status of seasonStatuses"
              [value]="status"
              >{{ status }}</mat-option
            ></mat-select
          ></mat-form-field
        >
        <mat-form-field *ngFor="let field of seasonDates"
          ><mat-label>{{ field.label }} (UTC)</mat-label
          ><input
            matInput
            type="datetime-local"
            step="1"
            [formControlName]="field.key"
        /></mat-form-field>
        <button mat-raised-button color="primary" type="submit">
          Применить</button
        ><button mat-button type="button" (click)="reset('seasons')">
          Сбросить
        </button>
      </div>
    </form>
    <p class="error" *ngIf="seasons.error">{{ seasons.error }}</p>
    <p *ngIf="seasons.loading">Загрузка…</p>
    <div class="table-scroll">
      <table
        mat-table
        [dataSource]="seasons.rows"
        matSort
        [matSortActive]="seasons.sort.active"
        [matSortDirection]="seasons.sort.direction"
        (matSortChange)="sort('seasons', $event)"
      >
        <ng-container matColumnDef="id"
          ><th mat-header-cell *matHeaderCellDef>ID</th>
          <td mat-cell *matCellDef="let row">{{ row.id }}</td></ng-container
        >
        <ng-container matColumnDef="name"
          ><th mat-header-cell *matHeaderCellDef>Название</th>
          <td mat-cell *matCellDef="let row">{{ row.name }}</td></ng-container
        >
        <ng-container matColumnDef="startAt"
          ><th mat-header-cell *matHeaderCellDef mat-sort-header>
            Начало (UTC)
          </th>
          <td mat-cell *matCellDef="let row">
            {{ row.startAt | date: 'dd.MM.yyyy HH:mm:ss':'UTC' }}
          </td></ng-container
        >
        <ng-container matColumnDef="endAt"
          ><th mat-header-cell *matHeaderCellDef mat-sort-header>
            Конец (UTC)
          </th>
          <td mat-cell *matCellDef="let row">
            {{ row.endAt | date: 'dd.MM.yyyy HH:mm:ss':'UTC' }}
          </td></ng-container
        >
        <ng-container matColumnDef="raffleEndAt"
          ><th mat-header-cell *matHeaderCellDef>Конец раффлов (UTC)</th>
          <td mat-cell *matCellDef="let row">
            {{ row.raffleEndAt | date: 'dd.MM.yyyy HH:mm:ss':'UTC' }}
          </td></ng-container
        >
        <ng-container matColumnDef="status"
          ><th mat-header-cell *matHeaderCellDef>Статус</th>
          <td mat-cell *matCellDef="let row">{{ row.status }}</td></ng-container
        >
        <ng-container matColumnDef="actions"
          ><th mat-header-cell *matHeaderCellDef>Действия</th>
          <td mat-cell *matCellDef="let row">
            <div class="actions">
              <button mat-button (click)="open(row, 'prizes')">
                Призовые места</button
              ><button mat-button (click)="open(row, 'score')">Очки</button
              ><button mat-button (click)="open(row, 'score-rewards')">
                Награды за очки
              </button>
            </div>
          </td></ng-container
        >
        <tr mat-header-row *matHeaderRowDef="seasonColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: seasonColumns"></tr>
      </table>
    </div>
    <p *ngIf="!seasons.loading && !seasons.error && !seasons.rows.length">
      Участие в сезонах по заданным фильтрам не найдено.
    </p>
    <mat-paginator
      [length]="seasons.amount"
      [pageIndex]="seasons.pageIndex"
      [pageSize]="seasons.pageSize"
      [pageSizeOptions]="[10, 20, 50, 100]"
      (page)="page('seasons', $event)"
    ></mat-paginator>
  </mat-tab>
  <mat-tab label="Квесты">
    <form [formGroup]="questForm" (ngSubmit)="apply('quests')">
      <fieldset>
        <legend>Параметры квеста</legend>
        <div class="filters">
          <mat-form-field
            ><mat-label>ID сезонов</mat-label
            ><input matInput formControlName="seasonIds" placeholder="1, 2, 3"
          /></mat-form-field>
          <mat-form-field
            ><mat-label>Типы</mat-label
            ><mat-select formControlName="types" multiple
              ><mat-option *ngFor="let type of questTypes" [value]="type">{{
                type
              }}</mat-option></mat-select
            ></mat-form-field
          >
          <mat-form-field
            ><mat-label>Группы через запятую</mat-label
            ><input matInput formControlName="groups"
          /></mat-form-field>
          <mat-form-field
            ><mat-label>Очки от</mat-label
            ><input
              matInput
              type="number"
              min="0"
              step="0.01"
              formControlName="minScoreAmount"
          /></mat-form-field>
          <mat-form-field
            ><mat-label>Очки до</mat-label
            ><input
              matInput
              type="number"
              min="0"
              step="0.01"
              formControlName="maxScoreAmount"
          /></mat-form-field>
        </div>
      </fieldset>
      <fieldset>
        <legend>Выполнение пользователя</legend>
        <div class="filters">
          <mat-form-field
            ><mat-label>Статусы выполнения</mat-label
            ><mat-select formControlName="statuses" multiple
              ><mat-option
                *ngFor="let status of questStatuses"
                [value]="status"
                >{{ status }}</mat-option
              ></mat-select
            ></mat-form-field
          >
          <mat-form-field
            ><mat-label>Типы отображения</mat-label
            ><mat-select formControlName="displayTypes" multiple
              ><mat-option *ngFor="let type of displayTypes" [value]="type">{{
                type
              }}</mat-option></mat-select
            ></mat-form-field
          >
          <mat-form-field *ngFor="let field of questDates"
            ><mat-label>{{ field.label }} (UTC)</mat-label
            ><input
              matInput
              type="datetime-local"
              step="1"
              [formControlName]="field.key"
          /></mat-form-field>
        </div>
      </fieldset>
      <button mat-raised-button color="primary" type="submit">Применить</button
      ><button mat-button type="button" (click)="reset('quests')">
        Сбросить
      </button>
    </form>
    <p class="error" *ngIf="quests.error">{{ quests.error }}</p>
    <p *ngIf="quests.loading">Загрузка…</p>
    <div class="table-scroll">
      <table
        mat-table
        [dataSource]="quests.rows"
        matSort
        [matSortActive]="quests.sort.active"
        [matSortDirection]="quests.sort.direction"
        (matSortChange)="sort('quests', $event)"
      >
        <ng-container matColumnDef="id"
          ><th mat-header-cell *matHeaderCellDef>Instance ID</th>
          <td mat-cell *matCellDef="let row">{{ row.id }}</td></ng-container
        >
        <ng-container matColumnDef="questDefinitionId"
          ><th mat-header-cell *matHeaderCellDef>Квест ID</th>
          <td mat-cell *matCellDef="let row">
            {{ row.questDefinitionId }}
          </td></ng-container
        >
        <ng-container matColumnDef="seasonId"
          ><th mat-header-cell *matHeaderCellDef>Сезон</th>
          <td mat-cell *matCellDef="let row">
            {{ row.questDefinition?.seasonId }}
          </td></ng-container
        >
        <ng-container matColumnDef="name"
          ><th mat-header-cell *matHeaderCellDef>Квест</th>
          <td mat-cell *matCellDef="let row">
            {{ row.questDefinition?.name }}
          </td></ng-container
        >
        <ng-container matColumnDef="type"
          ><th mat-header-cell *matHeaderCellDef>Тип</th>
          <td mat-cell *matCellDef="let row">
            {{ row.questDefinition?.type }}
          </td></ng-container
        >
        <ng-container matColumnDef="group"
          ><th mat-header-cell *matHeaderCellDef>Группа</th>
          <td mat-cell *matCellDef="let row">
            {{ row.questDefinition?.group || '—' }}
          </td></ng-container
        >
        <ng-container matColumnDef="displayType"
          ><th mat-header-cell *matHeaderCellDef>Отображение</th>
          <td mat-cell *matCellDef="let row">
            {{ row.displayType }}
          </td></ng-container
        >
        <ng-container matColumnDef="scoreAmount"
          ><th mat-header-cell *matHeaderCellDef>Очки</th>
          <td mat-cell *matCellDef="let row">
            {{ row.questDefinition?.scoreAmount }}
          </td></ng-container
        >
        <ng-container matColumnDef="status"
          ><th mat-header-cell *matHeaderCellDef>Статус</th>
          <td mat-cell *matCellDef="let row">{{ row.status }}</td></ng-container
        >
        <ng-container matColumnDef="completedAt"
          ><th mat-header-cell *matHeaderCellDef mat-sort-header>
            Выполнен (UTC)
          </th>
          <td mat-cell *matCellDef="let row">
            {{ (row.completedAt | date: 'dd.MM.yyyy HH:mm:ss':'UTC') || '—' }}
          </td></ng-container
        >
        <ng-container matColumnDef="claimedAt"
          ><th mat-header-cell *matHeaderCellDef mat-sort-header>
            Забран (UTC)
          </th>
          <td mat-cell *matCellDef="let row">
            {{ (row.claimedAt | date: 'dd.MM.yyyy HH:mm:ss':'UTC') || '—' }}
          </td></ng-container
        >
        <ng-container matColumnDef="progress"
          ><th mat-header-cell *matHeaderCellDef>Прогресс</th>
          <td mat-cell *matCellDef="let row">
            <details
              ><summary>Посмотреть</summary>
              <pre>{{ row.progress | json }}</pre></details
            >
          </td></ng-container
        >
        <tr mat-header-row *matHeaderRowDef="questColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: questColumns"></tr>
      </table>
    </div>
    <p *ngIf="!quests.loading && !quests.error && !quests.rows.length">
      Квесты с прогрессом или выполнением по заданным фильтрам не найдены.
    </p>
    <mat-paginator
      [length]="quests.amount"
      [pageIndex]="quests.pageIndex"
      [pageSize]="quests.pageSize"
      [pageSizeOptions]="[10, 20, 50, 100]"
      (page)="page('quests', $event)"
    ></mat-paginator> </mat-tab
></mat-tab-group>
